/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_No_OauthInputs */

const en_byoa_no_oauth = /** @type {(inputs: Byoa_No_OauthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This form stores API keys. To use a Claude or Codex subscription, sign in through its official agent on your own computer.`)
};

const id_byoa_no_oauth = /** @type {(inputs: Byoa_No_OauthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulir ini menyimpan kunci API. Untuk memakai langganan Claude atau Codex, login melalui agent resminya di komputermu sendiri.`)
};

/**
* | output |
* | --- |
* | "This form stores API keys. To use a Claude or Codex subscription, sign in through its official agent on your own computer." |
*
* @param {Byoa_No_OauthInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_no_oauth = /** @type {((inputs?: Byoa_No_OauthInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_No_OauthInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_no_oauth(inputs)
	return en_byoa_no_oauth(inputs)
});